import React, { useRef, useState } from "react";
import { Col, Row } from "reactstrap";
import Select from "react-select";
//i18n
import { withNamespaces } from "react-i18next";
import { task_status, taskStatusBack } from "../../constants/task_fields";

const DEBOUNCE_MS = 400;

const INITIAL_FILTERS = {
  status: [],
  rack: "",
  workstation: [],
  position: [],
  priorityMin: "",
  priorityMax: "",
};

// Convierte los arrays de selección múltiple a CSV para no cambiar el contrato
// (query string / firma de getTask) que ya usan las páginas padre y el backend.
const toPayload = (filters) => ({
  ...filters,
  status: filters.status.join(","),
  workstation: filters.workstation.join(","),
  position: filters.position.join(","),
});

const toOptions = (values, labelFor) => values.map((value) => ({ value, label: labelFor(value) }));

// P01021-145: filtro por servidor (estado, rack, estación, posición, rango de prioridad),
// compartido entre /tasks y /tasksWorkStations. Estado/Estación/Posición admiten selección múltiple.
const TaskFilters = function (props) {
  const [filters, setFilters] = useState(INITIAL_FILTERS);
  const filtersRef = useRef(filters);
  const debounceTimeout = useRef(null);

  const updateFilters = (patch, immediate) => {
    const next = { ...filtersRef.current, ...patch };
    filtersRef.current = next;
    setFilters(next);

    if (debounceTimeout.current) clearTimeout(debounceTimeout.current);
    if (immediate) {
      props.onFilterChange(toPayload(next));
    } else {
      debounceTimeout.current = setTimeout(() => props.onFilterChange(toPayload(filtersRef.current)), DEBOUNCE_MS);
    }
  };

  const stationNames = new Set((props.ws || []).map((w) => w.name));
  const positionOptions = (props.ws_positions || [])
    .map((p) => p.ws_pos)
    .filter((pos) => !stationNames.has(pos));

  const statusOptions = Object.keys(task_status)
    .filter((key) => parseInt(key) >= taskStatusBack.PENDIENTE_RETORNO)
    .map((key) => ({ value: key, label: task_status[key] }));
  const workstationOptions = (props.ws || []).map((w) => ({ value: w.name, label: w.name }));

  return (
    <Row className="mb-3">
      <Col md={2}>
        <label>{props.t("Estado")}</label>
        <Select
          isMulti
          placeholder={props.t("Todos")}
          value={toOptions(filters.status, (v) => task_status[v])}
          options={statusOptions}
          onChange={(selected) => updateFilters({ status: (selected || []).map((o) => o.value) }, true)}
        />
      </Col>
      <Col md={2}>
        <label>{props.t("Estación")}</label>
        <Select
          isMulti
          placeholder={props.t("Todas")}
          value={toOptions(filters.workstation, (v) => v)}
          options={workstationOptions}
          onChange={(selected) => updateFilters({ workstation: (selected || []).map((o) => o.value) }, true)}
        />
      </Col>
      <Col md={2}>
        <label>{props.t("Posición")}</label>
        <Select
          isMulti
          placeholder={props.t("Todas")}
          value={toOptions(filters.position, (v) => v)}
          options={positionOptions.map((pos) => ({ value: pos, label: pos }))}
          onChange={(selected) => updateFilters({ position: (selected || []).map((o) => o.value) }, true)}
        />
      </Col>
      <Col md={2}>
        <label>{props.t("Rack")}</label>
        <input
          type="text"
          className="form-control"
          value={filters.rack}
          onChange={(event) => updateFilters({ rack: event.target.value }, false)}
        />
      </Col>
      <Col md={2}>
        <label>{props.t("Prioridad mín.")}</label>
        <input
          type="number"
          className="form-control"
          value={filters.priorityMin}
          onChange={(event) => updateFilters({ priorityMin: event.target.value }, false)}
        />
      </Col>
      <Col md={2}>
        <label>{props.t("Prioridad máx.")}</label>
        <input
          type="number"
          className="form-control"
          value={filters.priorityMax}
          onChange={(event) => updateFilters({ priorityMax: event.target.value }, false)}
        />
      </Col>
    </Row>
  );
};

export default withNamespaces()(TaskFilters);
